import React, { useState, useEffect, useRef, lazy, Suspense } from "react";
import { Row, Col, Button, message, Form, Card } from "../../ui/ot";
import { useComponent } from "../controller/component_controller";
import ComponentLibraryModal from "./component_library";
import PageBlogModal from "../views/page_blog_modal";
import PageFrontendRowComponentSortModal from './page_frontend_row_component_sort_modal'
const PageDesign = ({
    frontend_component_blog_type_data,
    prefixTitle = "",
    setPageContainerData = () => { },
}) => {
    const [form] = Form.useForm();

    const [modalOpen, setModalOpen] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [axiosMode, setAxiosMode] = useState("get");
    const [currentRowIndex, setCurrentRowIndex] = useState(null);
    const [propertyJsonShow, setPropertyJsonShow] = useState(null);
    const handleAddRow = () => {
        setAxiosMode("post");
        setModalOpen(true);
        // form.resetFields();
    };
    const handleEditRow = (record) => {
        setAxiosMode("patch");
        setModalOpen(true);
        if (record) {
            if (!record?.frontend_column_frontend_component_blog_type_blog_data) {
                record["frontend_column_frontend_component_blog_type_blog_data"] = []
            }
            form.resetFields(record);
        } else {
            form.resetFields();
        }
    };
    const handleDeleteRow = (id) => {
        let data = [];
        if (id) {
            data = [
                {
                    page_id: id,
                },
            ];
        } else {
            // data = selectedRowsInfo.map((val) => {
            //     return {
            //         page_id: val?.page_id,
            //     };
            // });
        }
        if (data.length > 0) {
            // deletePageDesignData(data);
        } else {
            message.info("請選擇項目");
        }
    };

    const onFormFinish = (values) => {
        let newValues = { ...values };
        let permission_page_data = (newValues?.permission_page_data || []).map(
            (val) => {
                return { permission_id: val?.value };
            }
        );
        let page_menu_data = (newValues?.page_menu_data || []).map((val) => {
            return { menu_id: val?.value };
        });
        newValues = {
            ...newValues,
            page_menu_data,
            permission_page_data,
        };

        if (axiosMode === "post") {
            delete newValues.page_id;
            // postPageDesignData([newValues]);
        } else if (axiosMode === "patch") {
            // patchPageDesignData([values]);
        }
    };
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功");
            } else if (axiosMode === "patch") {
                message.success("修改成功");
            } else if (axiosMode === "delete") {
                message.success("刪除成功");
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗");
            } else if (axiosMode === "patch") {
                message.error("修改失敗");
            } else if (axiosMode === "delete") {
                message.error("刪除失敗");
            }
        }
        if (axiosMode !== "get") {
            setModalLoading(false);
            setModalOpen(false);
        }
    };
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true);
    };
    const setParamsFilter = (obj) => {
        //拿掉值為空或是null 的東西
        return Object.entries(obj).reduce(
            (all, [key, value]) =>
                value === "" ? { ...all } : { ...all, [key]: value },
            {}
        );
    };
    const componentRender = (component_name, blogTypeData) => {
        const Component = lazy(() => import(`../components/${component_name}`));
        let blogTypeDataFirst = blogTypeData.find(_ => true)
        let frontendColumnFrontendComponentBlogTypeBlogData = blogTypeDataFirst?.frontend_column_frontend_component_blog_type_blog_data || []
        if (blogTypeData.length !== 0 && frontendColumnFrontendComponentBlogTypeBlogData.length !== 0) {
            return (
                <Suspense fallback={<></>}>
                    <Component blogTypeData={blogTypeData} edit={true} />
                </Suspense>
            );
        } else {
            return (
                <Suspense fallback={<></>}>
                    <Component
                    // blogTypeData={blogTypeData}
                    />
                </Suspense>
            );
        }
    };
    const addContainer = (component_id, component_name, rowIndex) => {
        setPageContainerData((prev) => {
            return [
                ...prev,
                {
                    frontend_row_index: prev.length + 1,
                    page_frontend_row_data: [
                        {
                            frontend_column_index: 1,
                            frontend_row_frontend_column_data: [
                                {
                                    frontend_component_id: component_id,
                                    frontend_component_name: component_name,
                                    frontend_column_frontend_component_blog_type_data:
                                        [],
                                },
                            ],
                        },
                    ],
                },
            ];
        }, message.success("新增成功"));
    };
    const patchPageContainerData = (data, rowIndex) => {
        setPageContainerData((prev) => {
            console.log('setPageContainerData', prev)
            return findRowData("patch", prev, rowIndex, data);
        });
    };
    const deletePageContainerData = (rowIndex) => {
        // console.log(rowIndex)
        setPageContainerData((prev) => {
            // console(findRowData('delete', prev, rowIndex))
            return findRowData("delete", prev, rowIndex);
        });
        // console.log(pageContainerData)
    };

    const hiddenPageContainerData = (status = true, rowIndex) => {
        setPageContainerData((prev) => {
            let newPrev = prev.map((data, i) => {
                if (i + 1 === rowIndex) {
                    console.log(data)
                    data = { ...data, 'frontend_row_hidden': Boolean(status) }
                }
                return data
            })
            return newPrev
        });
    }


    const findRowData = (type, rowData_, rowIndex, data) => {
        // console.log(data)
        let rowData = [...rowData_];
        if (type === "delete") {
            rowData = [
                ...rowData.filter((map_item, map_index) => {
                    if (map_index + 1 !== rowIndex) {
                        return map_item;
                    }
                }),
            ];
            rowData.map((map_item, map_index) => {
                return {
                    ...map_item,
                    frontend_row_index: map_index + 1,
                };
            });
        } else if (type === "patch") {
            rowData = [
                ...rowData.map((map_item, map_index) => {
                    // console.log(map_item)

                    if (map_index + 1 === rowIndex) {
                        return {
                            ...map_item,
                            page_frontend_row_data:
                                map_item?.page_frontend_row_data?.map(
                                    (columnData, columnIndex) => {
                                        return {
                                            ...columnData,
                                            frontend_row_frontend_column_data:
                                                columnData?.frontend_row_frontend_column_data?.map(
                                                    (
                                                        componentData,
                                                        componentIndex
                                                    ) => {
                                                        return {
                                                            ...componentData,
                                                            frontend_column_frontend_component_blog_type_data:
                                                                data,
                                                        };
                                                    }
                                                ),
                                        };
                                    }
                                ),
                        };
                    } else {
                        return map_item;
                    }
                }),
            ];
        }
        return rowData;
    };
    const { ComponentData, getComponentData } = useComponent({
        onFinish: () => { },
        onBefore: () => { },
    });
    useEffect(() => {
        getComponentData({});
    }, []);
    return (
        <>
            <PageBlogModal
                propsOpen={modalOpen}
                propsSetOpen={setModalOpen}
                propsForm={form}
                onFinish={(value) => {
                    let frontend_column_frontend_component_blog_type_blog_data = value?.frontend_column_frontend_component_blog_type_blog_data?.map((val, index) => {
                        return {
                            ...val,
                            blog_index: index
                        }
                    })
                    console.log({
                        ...value,
                        frontend_column_frontend_component_blog_type_blog_data
                    })
                    patchPageContainerData(
                        [
                            {
                                ...value,
                                frontend_column_frontend_component_blog_type_blog_data
                            },
                        ],
                        currentRowIndex
                    );
                }}
                propertyJsonShow={propertyJsonShow}
            />
            <Row gutter={[10, 20]} justify="space-around">
                <Col span={24}>
                    <Row gutter={[8, 8]} style={{ justifyContent: "end" }}>
                        <Col>
                            <ComponentLibraryModal
                                addContainer={addContainer}
                            />
                        </Col>
                        <Col>
                            <PageFrontendRowComponentSortModal
                                frontend_component_blog_type_data={frontend_component_blog_type_data || []}
                                setPageContainerData={setPageContainerData}
                            />
                        </Col>
                    </Row>
                </Col>
                <Col span={24}>
                </Col>
                <Col span={24}>
                    <Row gutter={[10, 20]} >
                        {(frontend_component_blog_type_data || [])?.map(
                            (rowData, rowIndex) => {
                                return rowData?.page_frontend_row_data?.map(
                                    (columnData, columnIndex) => {
                                        let componentDatas = ComponentData;
                                        return (columnData?.frontend_row_frontend_column_data || [])?.map(
                                            (componentData, componentIndex) => {
                                                let frontendComponentId =
                                                    componentData?.frontend_component_id;
                                                let frontendComponentData =
                                                    componentDatas.find(
                                                        (element) => {
                                                            return (
                                                                element?.frontend_component_id ===
                                                                frontendComponentId
                                                            );
                                                        }
                                                    );
                                                let propertyJson =
                                                    frontendComponentData?.property_json;
                                                let propertyJsonShow =
                                                    propertyJson?.show;
                                                const BlogTypeData =
                                                    (componentData?.frontend_column_frontend_component_blog_type_data || []).map(
                                                        (BlogTypeData) => {
                                                            return {
                                                                ...BlogTypeData,
                                                                frontend_column_frontend_component_blog_type_blog_data:
                                                                    (BlogTypeData?.frontend_column_frontend_component_blog_type_blog_data || []).map(
                                                                        (
                                                                            BlogData
                                                                        ) => {
                                                                            return {
                                                                                ...BlogData,
                                                                                extermal_link_check: BlogData?.extermal_link_check,
                                                                                extermal_link_check_replace: !!(BlogData?.extermal_link_check === 1)

                                                                            };
                                                                        }
                                                                    ),
                                                            };
                                                        }
                                                    );

                                                return (
                                                    <Col span={24}>
                                                        <Card>
                                                            <Row
                                                                gutter={[10, 20]}
                                                                justify="space-around"
                                                            >

                                                                {/* <Space> */}
                                                                {
                                                                    !Boolean(rowData?.frontend_row_hidden) ? (
                                                                        <>
                                                                            <Col span={24}>
                                                                                <Row
                                                                                    gutter={[10, 20]}
                                                                                    justify="left"
                                                                                    id={rowIndex}

                                                                                    key={rowIndex}
                                                                                >
                                                                                    <Col span={24}>
                                                                                        <Row
                                                                                            gutter={[8, 8]}
                                                                                        >
                                                                                            <Col>
                                                                                                <Button
                                                                                                    type="primary"
                                                                                                    onClick={() => {
                                                                                                        let record =
                                                                                                            BlogTypeData?.find(
                                                                                                                (
                                                                                                                    e
                                                                                                                ) =>
                                                                                                                    true
                                                                                                            );

                                                                                                        let blog_type_id = !!record?.blog_type_id ? record?.blog_type_id : null
                                                                                                        setCurrentRowIndex(
                                                                                                            rowIndex +
                                                                                                            1
                                                                                                        );
                                                                                                        setPropertyJsonShow(
                                                                                                            propertyJsonShow
                                                                                                        );
                                                                                                        handleEditRow(
                                                                                                            { ...record, blog_type_id },
                                                                                                        );
                                                                                                    }}
                                                                                                >
                                                                                                    {`模板編輯`}
                                                                                                </Button>
                                                                                            </Col>
                                                                                            <Col>
                                                                                                <Button
                                                                                                    onClick={(
                                                                                                        e
                                                                                                    ) => {
                                                                                                        deletePageContainerData(
                                                                                                            rowIndex +
                                                                                                            1
                                                                                                        );
                                                                                                    }}
                                                                                                >
                                                                                                    刪除模板
                                                                                                </Button>
                                                                                            </Col>
                                                                                            <Col>
                                                                                                <Button
                                                                                                    type='danger'
                                                                                                    onClick={(
                                                                                                        e
                                                                                                    ) => {
                                                                                                        hiddenPageContainerData(
                                                                                                            true,
                                                                                                            rowIndex +
                                                                                                            1
                                                                                                        );
                                                                                                    }}
                                                                                                >
                                                                                                    隱藏模板
                                                                                                </Button>
                                                                                            </Col>
                                                                                        </Row>
                                                                                    </Col>

                                                                                </Row>
                                                                            </Col>
                                                                            <Col span={24}>
                                                                                {componentRender(
                                                                                    componentData?.frontend_component_name,
                                                                                    componentData?.frontend_column_frontend_component_blog_type_data
                                                                                )}
                                                                            </Col>
                                                                        </>

                                                                    ) : (
                                                                        <>
                                                                            <Col span={24}>
                                                                                <Row
                                                                                    gutter={[10, 20]}
                                                                                    justify="left"
                                                                                    id={rowIndex}

                                                                                    key={rowIndex}
                                                                                >
                                                                                    <Col span={24}>
                                                                                        <Row
                                                                                            gutter={[8, 8]}
                                                                                        >
                                                                                            <Col>
                                                                                                <Button
                                                                                                    type="primary"
                                                                                                    onClick={() => {
                                                                                                        let record =
                                                                                                            BlogTypeData?.find(
                                                                                                                (
                                                                                                                    e
                                                                                                                ) =>
                                                                                                                    true
                                                                                                            );

                                                                                                        let blog_type_id = !!record?.blog_type_id ? record?.blog_type_id : null
                                                                                                        setCurrentRowIndex(
                                                                                                            rowIndex +
                                                                                                            1
                                                                                                        );
                                                                                                        setPropertyJsonShow(
                                                                                                            propertyJsonShow
                                                                                                        );
                                                                                                        handleEditRow(
                                                                                                            { ...record, blog_type_id },
                                                                                                        );
                                                                                                    }}
                                                                                                >
                                                                                                    {`模板編輯`}
                                                                                                </Button>
                                                                                            </Col>
                                                                                            <Col>
                                                                                                <Button
                                                                                                    onClick={(
                                                                                                        e
                                                                                                    ) => {
                                                                                                        deletePageContainerData(
                                                                                                            rowIndex +
                                                                                                            1
                                                                                                        );
                                                                                                    }}
                                                                                                >
                                                                                                    刪除模板
                                                                                                </Button>
                                                                                            </Col>
                                                                                            <Col>
                                                                                                <Button
                                                                                                    onClick={(
                                                                                                        e
                                                                                                    ) => {
                                                                                                        hiddenPageContainerData(
                                                                                                            false,
                                                                                                            rowIndex +
                                                                                                            1
                                                                                                        );
                                                                                                    }}
                                                                                                >
                                                                                                    顯示模板
                                                                                                </Button>
                                                                                            </Col>
                                                                                        </Row>
                                                                                    </Col>

                                                                                </Row>
                                                                            </Col>
                                                                        </>
                                                                    )
                                                                }

                                                            </Row>
                                                        </Card>
                                                    </Col>
                                                );
                                            }
                                        );
                                    }
                                );
                            }
                        )}
                    </Row>
                </Col>
            </Row>
        </>
    );
};
export default PageDesign;
